import React, { useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { Header } from './components/Header';
import { DashboardOverview } from './pages/DashboardOverview';
import { CustomerManagement } from './pages/CustomerManagement';
import { DeliveryOversight } from './pages/DeliveryOversight';
import { RiderManagement } from './pages/RiderManagement';
import { JobAssignment } from './pages/JobAssignment';
import { EarningsPayouts } from './pages/EarningsPayouts';
import { DispatchOverview } from './pages/DispatchOverview';
import { FleetManagement } from './pages/FleetManagement';
import { AuditLogs } from './pages/AuditLogs';
import { Support } from './pages/Support';
import { Notifications } from './pages/Notifications';
import { PricingConfig } from './pages/PricingConfig';
import { motion, AnimatePresence } from 'framer-motion';
export function App() {
  const [activePage, setActivePage] = useState('dashboard');
  const getPageTitle = () => {
    switch (activePage) {
      case 'dashboard':
        return 'Dashboard Overview';
      case 'customers':
        return 'Customer Management';
      case 'deliveries':
        return 'Delivery Oversight';
      case 'riders':
        return 'Rider Management';
      case 'jobs':
        return 'Job Assignment';
      case 'earnings':
        return 'Earnings & Payouts';
      case 'dispatch':
        return 'Live Dispatch Map';
      case 'fleet':
        return 'Fleet & Bike Management';
      case 'audit':
        return 'Security & Audit Logs';
      case 'support':
        return 'Support Center';
      case 'notifications':
        return 'Notifications';
      case 'pricing':
        return 'Pricing & Charges';
      case 'settings':
        return 'System Settings';
      default:
        return 'Dashboard';
    }
  };
  const renderContent = () => {
    switch (activePage) {
      case 'dashboard':
        return <DashboardOverview data-id="element-0" />;
      case 'customers':
        return <CustomerManagement data-id="element-1" />;
      case 'deliveries':
        return <DeliveryOversight data-id="element-2" />;
      case 'riders':
        return <RiderManagement data-id="element-3" />;
      case 'jobs':
        return <JobAssignment data-id="element-4" />;
      case 'earnings':
        return <EarningsPayouts data-id="element-5" />;
      case 'dispatch':
        return <DispatchOverview data-id="element-6" />;
      case 'fleet':
        return <FleetManagement data-id="element-7" />;
      case 'audit':
        return <AuditLogs data-id="element-8" />;
      case 'support':
        return <Support data-id="element-9" />;
      case 'notifications':
        return <Notifications data-id="element-10" />;
      case 'pricing':
        return <PricingConfig data-id="element-11" />;
      case 'settings':
        return <div className="flex flex-col items-center justify-center h-[60vh] text-slate-400" data-id="element-12">
            <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mb-4" data-id="element-13">
              <span className="text-2xl" data-id="element-14">⚙️</span>
            </div>
            <h3 className="text-lg font-medium text-slate-600" data-id="element-15">
              Settings Panel
            </h3>
            <p data-id="element-16">System configuration options would go here.</p>
          </div>;
      default:
        return <DashboardOverview data-id="element-17" />;
    }
  };
  return <div className="flex min-h-screen bg-slate-50 font-sans" data-id="element-18">
      <Sidebar activePage={activePage} setActivePage={setActivePage} data-id="element-19" />

      <div className="flex-1 ml-64 flex flex-col min-w-0" data-id="element-20">
        <Header title={getPageTitle()} onNotificationClick={() => setActivePage('notifications')} data-id="element-21" />

        <main className="flex-1 p-8 overflow-y-auto" data-id="element-22">
          <AnimatePresence mode="wait" data-id="element-23">
            <motion.div key={activePage} initial={{
            opacity: 0,
            x: 10
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -10
          }} transition={{
            duration: 0.2
          }} className="max-w-7xl mx-auto" data-id="element-24">
              {renderContent()}
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
    </div>;
}